import React from 'react'
// import { Card } from 'react-bootstrap'
import Header from '../../../header'
import Footer from "../../../footer"

function careers() {
    return (
        <div className="main-wrapper">
            <Header />
            <div style={{ marginTop: '5%' }}>
                {/* <Bannerpage /> */}
                {/*  */}
                <div className="inner-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="instructor-wrap border-bottom-0 m-0">
                                    <div className="about-instructor align-items-center"></div>
                                </div>
                                <h2>{"Journals Feed"}</h2>

                                <div
                                    className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 "
                                    style={{ justifyContent: "end" }}
                                >
                                    <div className="cou-info">
                                        <h2 style={{ textAlign: "center",color:"white" }}>
                                            careers
                                        </h2  >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='container mt-3'>
                <div>
                    <div style={{ fontWeight: 700, fontSize: "19px", color: "black" }}>
                        At JournalsFeed Publishing, our mission is to accelerate the pace of global scientific discovery.
                    </div>
                    <br />
                    We support international researchers in publishing their work in top-tier journals and are committed to delivering trusted, high-quality information to the health and science communities.
                    <br />
                    <br />
                    As a small, agile company operating across borders, we offer a collaborative and flexible work environment where your contributions can make a meaningful impact on people&apos;s lives.
                    <br /><br />
                    Our culture promotes exceptional career development opportunities—both locally and internationally—alongside the chance to work with cutting-edge technology and drive meaningful change in the world of science and publishing.
                    <br />

                    <div style={{ fontWeight: 700, fontSize: "19px", color: "black" }}>
                        Explore a Career with JournalsFeed Publishing
                    </div>
                    <br />
                    At JournalsFeed Publishing, we offer a diverse range of career opportunities for professionals across various disciplines—including Editorial & Publishing, Sales & Marketing, Technology & IT, Strategy & Communications, Operations, Finance, and Human Resources. This wide scope allows you to shape a dynamic and varied career across multiple functions and areas of expertise.
                    <br /><br />
                    If you&apos;re passionate about advancing global research and would like to be part of our mission, we encourage you to get in touch using the contact form on this page.
                    <br /><br />
                    While many of our full-time positions are based in Spain, we also collaborate with a global network of consultants—so location is rarely a barrier.
                    <br /><br />
                    Join us and help shape the future of science, publishing, and innovation.
                    <br /><br />
                    Internships
                    <br /><br />
                    <div style={{ fontWeight: 700, fontSize: "19px", color: "black" }}>
                        Grow with Us: Internships at JournalsFeed Publishing
                    </div>
                    <br />
                    At JournalsFeed, we believe that nurturing talent is key to maintaining our innovative edge. That&apos;s why we actively support and mentor our interns, offering them a strong foundation to launch their careers.
                    <br /><br />
                    We&apos;re committed to fostering a culture of learning, initiative, creativity, and independence. Through a wide range of learning opportunities and a structured performance development program, we help ambitious individuals grow into successful professionals.
                    <br /><br />
                    We are currently looking for motivated and curious students to join our team and contribute to the development of exciting new products.
                    <br /><br />
                    If you&apos;re ready to take the next step in your career journey, contact us using the form on the right side of this page. We&apos;ll be happy to provide more information about our available internships and how to apply.
                    <br /><br />
                    <div style={{ fontWeight: 700, fontSize: "19px", color: "black" }}>
                        Submit Your Application:
                    </div>
                    <br />
                    Please use the form to upload your CV and cover letter to contact@journalsfeed.com. We will review your application and get back to you as soon as possible.
                    <br /><br />
                    Kindly ensure that all required fields marked with an asterisk (*) are completed before submitting your information. Thank you for your interest in joining JournalsFeed Publishing.
                    <br /><br />

                </div>
            </div>
             <Footer />


        </div>
    )
}

export default careers